import { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import useToast from '../util/hooks/useToast';

const useCustomQuery = ({ query, onData, onError }) => {
  const Toast = useToast();
  const [isSuccess, setIsSuccess] = useState(null);
  const [getData, { error, data, loading }] = useLazyQuery(query, {
    nextFetchPolicy: 'no-cache',
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (loading && isSuccess) setIsSuccess(false);
  }, [loading]);

  useEffect(() => {
    if (data) {
      onData?.(data, setIsSuccess);
    }
    if (error) {
      if (error?.message?.toLowerCase() === 'sorry you have no access to this resource.') {
        Toast.error(error);

        navigate('/');

        // To clear the current profile and its associated Redux store.
        window.location.reload();
        return;
      }
      onError?.(error, data);
    }
  }, [data, error]);

  return [getData, loading, data];
};

export default useCustomQuery;
